export default __webpack_public_path__ + "static/media/advcol2.e04564a0.svg";